import React, { useState, useReducer, useEffect } from 'react';
import { Popup, Position } from 'devextreme-react/popup';
import FileUploader from 'devextreme-react/file-uploader';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import { SelectBox } from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import { doMail, getAllUsers, saveHtmlTpl, getTZ, getSchedules, saveSchedule } from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import { Validator, RequiredRule, EmailRule ,CustomRule} from 'devextreme-react/validator';
import Button from 'devextreme-react/button';
import moment from 'moment';
import { TagBox } from 'devextreme-react/tag-box';
import { Toast } from 'devextreme-react/toast';
import ScrollView from 'devextreme-react/scroll-view';
import TemplateEditor from '../templateEditor/TemplateEditor';
import { CheckBox } from 'devextreme-react/check-box';
import { fileTypeInfo } from '../../../common/utils'
const initialState = { allUsers: null, emailTpl: null, timezones: [] }
const SchedulerHandler = (props) => {
    const [isEmail, setIsEmail] = useState(false)
    const showTemplateEditor = props.showTemplateEditor
    let isEdit = false, editInfo = {};
    if (!isEmail && !props.isAdd) {
        isEdit = true;
        editInfo = props.data
    } else { isEdit = false; editInfo = {}; }
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const [mailSent, setMailSent] = useState(false)
    const { allUsers, timezones } = state
    const [selectedFiles, setSelectedFiles] = useState([])
    const [title, setTitle] = useState(isEdit ? editInfo.subject : '')
    const [desc, setDesc] = useState('')
    const [bcc, setBcc] = useState(isEdit ? editInfo.bcc : [])
    const [cc, setCc] = useState(isEdit ? editInfo.cc : [])
    const [to, setTo] = useState(isEdit ? editInfo.to : [])
    const [currDate, setCurrDate] = useState(isEdit ? editInfo.schedularDatetime : new Date())
    const [tzVal, setTZ] = useState(isEdit ? editInfo.timeZone : 'Eastern Standard Time')
    const [emailList, setEmailList] = useState([])
    const [empList, updateEmp] = useState([])
    const [fileTypeVal, setFileType] = useState(null)
    const [showErr, setShowErr] = useState(null)
    const [metricsList, updateMetrics] = useState([])
    const [showMailer, enableMailer] = useState(false)
    const empEmail = e => updateEmp(e.value)
    const metricsEmail = e => updateMetrics(e.value)
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });
    let mailLst = []
    useEffect(() => { getAllUsers(dispatch); getTZ(dispatch); }, [])
    const resetFrm = () => { setSelectedFiles([]); setTitle(''); setDesc(''); setShowErr(false); setFileType(null) }

    const [getTemplateData, setGetTemplateData] = useState("")  // state to manipulate/get Template Content

    const sendMail = () => {
        let sub = title.trim();
        setShowErr(true)
        // if (sub && to.length > 0 && fileTypeVal == 'htm') {
        if ((to.length > 0 || cc.length > 0 || bcc.length > 0) && sub && fileTypeVal == 'htm') {
            let formData = new FormData();
            formData.append('subject', title)
            formData.append('to', to.join(','))
            formData.append('cc', cc.join(','))
            formData.append('bcc', bcc.join(','))
            //formData.append('tplPath', state.emailTpl.path)
            formData.append('message', getTemplateData)  // mail messsage as template content
            doMail(dispatch, formData)
            resetFrm()
            enableMailer(false)
            setMailSent(true)
            setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Mail sent!' });
        }
        else {

        }

    }

    function onNewItem(args) {
        const newValue = args.text;
        args.customItem = { "emailId": newValue, "employeeName": newValue, employeeId: 'custom' }
        let newList = [{ "emailId": newValue, "employeeName": newValue, employeeId: 'custom' }, ...emailList]
        setEmailList(newList)
    }

    const onFileSelect = e => {
        let type = e.value[0].type
        let val;
        if (type.indexOf('htm') > -1)
            val = 'htm'
        setFileType(val)
        setSelectedFiles(e.value);
        if (val == 'htm') {
            let formData = new FormData();
            formData.append('filedata', e.value[0])
            saveHtmlTpl(dispatch, formData)
        }
    }

    const onSaveSchedule = () => {
        let sub = title.trim();
        setShowErr(true)
        if ((to.length > 0 || cc.length > 0 || bcc.length > 0) && sub && fileTypeVal == 'htm') {
            let formData = new FormData();
            formData.append('subject', title)
            formData.append('to', to.join(','))
            formData.append('cc', cc.join(','))
            formData.append('bcc', bcc.join(','))
            formData.append('tplPath', state.emailTpl.path)
            formData.append('dateTime', moment(currDate).format("YYYY-MM-DD HH:mm"))
            formData.append('timezone', tzVal)
            formData.append('message', getTemplateData)
            saveSchedule(dispatch, formData)
            resetFrm()
            props.closeIt()
            setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Mail schedule created!' });
        }
    }

    const updateSchedule = () => {
        let sub = title.trim();
        setShowErr(true)
        if (isDataValid) {

            let formData = new FormData();
            formData.append('id', editInfo.id)
            formData.append('status', editInfo.status)
            formData.append('subject', title)
            formData.append('to', to.join(','))
            formData.append('cc', cc.join(','))
            formData.append('bcc', bcc.join(','))
            formData.append('tplPath', (state.emailTpl && state.emailTpl.path) ? state.emailTpl.path : editInfo.tplPath)
            formData.append('dateTime', moment(currDate).format("YYYY-MM-DD HH:mm"))
            formData.append('timezone', tzVal)
            saveSchedule(dispatch, formData)
            resetFrm()
            props.closeIt()
            setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Mail schedule updated!' });
        }
    }

    useEffect(() => {
        if (allUsers && allUsers.employee) {
            setEmailList(allUsers.employee)
        }
    }, [allUsers])

    const isDataValid = () => {
        let sub = title.trim();
        setShowErr(true)
        if ((to.length > 0 || cc.length > 0 || bcc.length > 0) && sub && (fileTypeVal == 'htm' || (!props.isAdd && editInfo.tplPath))) {
            return true
        } else return false;
    }

    const handleIsEMail = () => {
        setIsEmail(!isEmail)
    }

    const validateFields = () => {
        if(to.length > 0 ||cc.length > 0 || bcc.length > 0)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    return (
        <div className="mailerAdj" style={{ maxWidth: "100%" }}>
            {!mailSent
                &&
                <div>
                    <CheckBox value={isEmail} onValueChanged={handleIsEMail} text="Send Immediately" />
                    <br />
                    <br />
                    {!isEmail
                        &&
                        <>
                            <div className="dx-field">
                                <div className="dx-field-label">Date and time</div>
                                <DateBox className="dx-field-value" defaultValue={currDate}
                                    type="datetime"
                                    onValueChanged={e => setCurrDate(e.value)} useMaskBehavior={true}
                                />
                            </div>
                            <div className="dx-field">
                                <div className="dx-field-label">Time Zone</div>

                                <SelectBox className="dx-field-value"
                                    dataSource={timezones}
                                    displayExpr="tzName"
                                    value={tzVal}
                                    valueExpr="tzName"
                                    onValueChanged={e => setTZ(e.value)}
                                    searchEnabled={true}
                                    {...{
                                        searchModeOption: 'contains',
                                        searchExprOption: 'Name',
                                        searchTimeoutOption: 200,
                                        minSearchLengthOption: 0
                                    }}
                                />

                            </div>
                        </>
                    }
                    <div className="dx-field">
                        To <TagBox
                            acceptCustomValue={true}
                            onCustomItemCreating={onNewItem}
                            className="dx-field-value"
                            items={emailList}
                            defaultValue={isEdit ? editInfo.to : []}
                            showSelectionControls={true}
                            maxDisplayedTags={4}
                            showMultiTagOnly={false}
                            onValueChanged={e => setTo(e.value)}
                            displayExpr="employeeName"
                            valueExpr="emailId"
                            searchEnabled={true}
                            selectAllMode="allPages" >
                            <Validator>
                            <CustomRule
                        validationCallback={validateFields}
                        message="Please enter a value in T0 , CC or BCC"/>
                                <EmailRule message="Email is invalid" /> </Validator>
                        </TagBox>
                    </div>
                    <div className="dx-field">
                        <div className="dx-field-label">Cc</div>
                        <div className="dx-field">
                            <TagBox
                                style={{ "width": "100%" }}
                                className="dx-field-value"
                                items={emailList}
                                defaultValue={isEdit ? editInfo.cc : []}
                                showSelectionControls={true}
                                maxDisplayedTags={4}
                                showMultiTagOnly={false}
                                onValueChanged={e => setCc(e.value)}
                                displayExpr="employeeName"
                                valueExpr="emailId"
                                searchEnabled={true}
                                selectAllMode="allPages" acceptCustomValue={true}
                                onCustomItemCreating={onNewItem}>
                                <Validator>
                                <CustomRule
                        validationCallback={validateFields}
                        message="Please enter a value in T0 , CC or BCC is expected"/>
                        <EmailRule message="Email is invalid" /></Validator>
                            </TagBox>
                        </div>
                    </div>

                    <div className="dx-field">
                        <div className="dx-field-label">Bcc</div>
                        <div className="dx-field">
                            <TagBox
                                style={{ "width": "100%" }}
                                acceptCustomValue={true}
                                onCustomItemCreating={onNewItem}
                                className="dx-field-value"
                                items={emailList}
                                defaultValue={isEdit ? editInfo.bcc : []}
                                showSelectionControls={true}
                                maxDisplayedTags={4}
                                showMultiTagOnly={false}
                                onValueChanged={e => setBcc(e.value)}
                                displayExpr="employeeName"
                                valueExpr="emailId"
                                searchEnabled={true}
                                selectAllMode="allPages" >
                                <Validator>
                                <CustomRule
                        validationCallback={validateFields}
                        message="Please enter a value in T0 , CC or BCC is expected"/>
                                    <EmailRule message="Email is invalid" /></Validator>
                            </TagBox>
                        </div>
                    </div>

                    <div className="dx-field">
                        <div className="dx-field-label">Subject *</div>
                        <TextBox name="FirstName" value={title} onValueChanged={e => setTitle(e.value)} className="dx-field-value" >
                            <Validator><RequiredRule message="Subject is required" /> </Validator>
                        </TextBox>
                    </div>

                    <div className="dx-field mail">
                        <div className="dx-field-label">Template *</div>
                        <FileUploader className="dx-field-value" readyToUploadMessage="" selectButtonText="Choose file" labelText="Max. File Size 4 MB."  accept="*" uploadMode="useForm" onValueChanged={onFileSelect} value={selectedFiles} allowedFileExtensions={['.html', '.htm']} />
                        <div className="dx-field-value">{fileTypeInfo(['HTML', 'HTM'])}</div>
                    </div>

                    {/* Email Templater */}
                    {showTemplateEditor && selectedFiles.length > 0 && <TemplateEditor template={selectedFiles[0]} setGetTemplateData={setGetTemplateData} />}


                    <span>{(showErr && selectedFiles.length < 1) && < span className="err-lbl">Please upload HTML template file.</span>}</span>

                    {isEmail
                        &&
                        <div className="cbtn" style={{ "textAlign": "right" }}>
                            <Button style={{ "marginRight": "14px" }} onClick={props.closeIt} text="Cancel" type="normal" />
                            <Button onClick={sendMail} text="Send" type="success" useSubmitBehavior={true} />
                        </div>
                    }
                    {!isEmail
                        &&
                        <div className="cbtn" style={{ "textAlign": "right" }}>
                            <Button style={{ "marginRight": "14px" }} onClick={props.closeIt} text="Cancel" type="normal" />
                            {props.isAdd && <Button onClick={onSaveSchedule} text="Create Schedule" type="success" useSubmitBehavior={true} />}
                            {!props.isAdd && <Button onClick={updateSchedule} text="Update Schedule" type="success" useSubmitBehavior={true} />}
                        </div>
                    }

                </div>
            }
            {mailSent
                &&
                <div>
                    <h5>Mail Sent!</h5>
                    <br />
                    <Button onClick={() => setMailSent(false)} text="Send New Mail" type="success" />
                    <Button style={{ "marginLeft": "14px" }} onClick={props.closeIt} text="Go Back" type="normal" />
                </div>
            }
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={2000}
            />
        </div>
    );
}

export default SchedulerHandler;